import Player from '@vimeo/player'
import { select, getAttribute, addClass, removeClass, on } from 'modules/dom'
import Cookies from 'js-cookie'

const NOTIFICATION_SELECTOR = '.js-notification'
const NOTIFICATION_CLOSE_SELECTOR = '.js-button-close'
const NOTIFICATION_ACTIVE_CLASS = 'oembed__notification--active'
const COOKIE_PROPS = { expires: 365 }

export default el => {
  // Vimeo progress tracking
  let vimeoPlayedTime = 0
  let interval = null
  let played = false
  let sentTime = null
  const heartBeatDelay = 15000
  const iframe = select('iframe', el)
  const postID = getAttribute('data-post-id', el)
  const notificationEl = select(NOTIFICATION_SELECTOR, el)
  const closeEl = select(NOTIFICATION_CLOSE_SELECTOR, el)
  const cookieName = `STYXKEY_${postID}_vimeo_hidden`

  if (iframe) {
    const player = new Player(iframe)
    player.on('timeupdate', function (data) {
      vimeoPlayedTime = data.seconds
    })
    const sendTrackingData = () => {
      player.getDuration().then((duration) => {
        if (sentTime === vimeoPlayedTime) {
          return
        }
        sentTime = vimeoPlayedTime
        jQuery.ajax({
          url : wpVars['ajaxUrl'],
          data : {
            post_id: postID,
            action : 'ecl_track_vimeo_watched_time',
            duration: parseInt(duration),
            time: vimeoPlayedTime
          },
          method : 'POST',
          error : function(error) {
            console.log(error)
          }
        })
      })
    }
    const updateViewCount = () => {
      if (!played) {
        played = true
        // Update view count
        jQuery.ajax({
          url: wpVars['ajaxUrl'],
          method: 'POST',
          data: {
            post_id: postID,
            action: 'ecl_increase_vimeo_view_count'
          },
          error: function (error) {
            console.log(error)
          }
        })
      }
    }
    const showNotification = () => {
      if (!Cookies.get(cookieName) && notificationEl) {
        addClass(NOTIFICATION_ACTIVE_CLASS, notificationEl)
      }
    }
    const hideNotification = () => {
      if (notificationEl) {
        removeClass(NOTIFICATION_ACTIVE_CLASS, notificationEl)
        Cookies.set(cookieName, '1', COOKIE_PROPS)
      }
    }
    if (notificationEl && closeEl) {
      on('click', hideNotification, closeEl)
    }
    /**
     * Issue: Synchronous request with 'beforeUnload' will cause the browser to become un-responsive until the request is complete.
     * Solution: Send request every 15s same as default Wordpress heartbeat does
     */
    player.on('play', function () {
      interval = setInterval(sendTrackingData, heartBeatDelay)
      updateViewCount()
      showNotification()
    })
    player.on('pause', function () {
      clearInterval(interval)
      sendTrackingData()
    })
    player.on('ended', function () {
      sendTrackingData()
    })
  }
}
